var _circle, _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    fill: "#EB2019"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2726_9374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 23,
    width: 40,
    height: 39
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 23H22.5V62H61.5V23Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2726_9374)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5426 37.3891L39.3224 47.6094L34.457 42.7441",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2726_9374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 23,
    width: 40,
    height: 39
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 23H61.5V62H22.5V23Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2726_9374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.9766 42.5C59.9766 52.4282 51.9282 60.4766 42 60.4766C32.0718 60.4766 24.0234 52.4282 24.0234 42.5C24.0234 32.5718 32.0718 24.5234 42 24.5234C51.9282 24.5234 59.9766 32.5718 59.9766 42.5Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.84d250208d4f0386035b850d950893e1.svg";
export { ForwardRef as ReactComponent };